/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react'
import { Card, Box, Tab, Switch, styled } from '@mui/material'
import TabContext from '@mui/lab/TabContext'
import TabList from '@mui/lab/TabList'
import { compFreqOptions, lawTypes, regulationTypes } from 'src/Entities/Governance'
// import { useCompStore } from 'src/Components/Governance/Store/ComplianceStore'
import { matrix } from 'src/Entities/ComplianceListViewEntity'

import { useNavigate, useParams } from 'react-router'
import TransferComplianceContainer from './TransferComplainceContainer'
import { useComplianceStore } from '../Compliance/store/ComplianceContainerStore'
import PaginationComp from 'src/Common/ui/PaignationComp'
import { Button } from 'src/Common/ui/button'
import TcModal from './TcModal'
import { GetAllCompliancePreview } from 'src/API/ComplianceAPI'
import { useLocation } from 'react-router-dom'
import { cn } from 'src/lib/utils'
import { BiTransferAlt } from 'react-icons/bi'
import { indexOf } from 'lodash'
import CustomSearchField from 'src/Common/ui/searchInput'
import { useBodyPreviewStore } from './store/BodyPreviewStore'
import { bodyPreview, transferBody, transferCompliance } from 'src/Entities/CommonEntities'
import { GetAllBodyPreview } from 'src/API/PreviewAPI'
import { toaster } from 'src/Common/ui/Toaster'
import Loading from 'src/Common/ui/Loading'
import { typeBodyCompCondition, typePreviewTransferCondition, typeRouting } from 'src/Entities/TransferEntities'
import TransferRaciContainer from '../Compliance/TransferRaciContainer'
function TransferPreview ({ type }) {
    const location = useLocation()

    const [ value, setValue ] = useState()
    const [ data, setData ] = useState({})
    const navigate = useNavigate()
    const { username } = useParams()
    const route = typeRouting(type)
    const routePath = typeBodyCompCondition(type) ? '/GRC/' + username + route : '/GRC' + route
    const queryParams = new URLSearchParams(location.search)
    const bodyType = queryParams.get('bodyType')

    const matrixParam = +queryParams.get('matrix')
    const compUserId = +queryParams.get('userId')
    const roleId = +queryParams.get('roleId')
    // const [ compUserId, setCompUserId ] = useState(+complianceUserId)
    const [ openModal, setOpenModal ] = useState(false)
    const [ tempData, setTempData ] = useState([])
    const [ selectAll, setSelectAll ] = useState(false)

    const [ loading, setLoading ] = useState(false)
    const [ compliancePreview, setCompliancePreview ] = useState([])
    const [ deFaultRaciId, setDefaultRaciId ] = useState(null)
    const getCompliancePreview = async () => {
        setLoading(true)
        const orgId = localStorage.getItem('orgId')
        const complianceType = 2
        let arr = [ 0, 0, 0, 0 ]
        setValue(bodyType)
        try {
            let finalData = []
            if (typePreviewTransferCondition(type)) {
                const getData = await GetAllBodyPreview(compUserId, orgId, bodyType, roleId)
                const response = await getData
                setData(response.data)
                for (let i = 0; i < 4; i++) {
                    const sepData = response.data.bodyPreview.map((item, index) => {
                        item.id = index
                        item.checkbox = false
                        item.raciiMatrices = [ 1, 2, 3, 4 ].map(ele => {
                            const find = item.raciiMatrices.find(item => item.raciId === ele)
                            if (find) {
                                return find
                            }
                            return {
                                raciId: ele,
                                userId: null,
                                id: null,
                                organizationId: null,
                                orgRegulationId: null,
                                department: null,
                                departmentId: null,
                                user: null,
                                profilePic: null,
                                role: null,
                                roleId: null,
                                status: null,
                                type: null
                            }
                        })
                        return item
                    }).filter(ele => ele !== null).filter((ele) => {
                        if (+ele.raciiMatrices[i].userId === +compUserId) {
                            return ele
                        }
                        return null
                    }).filter(ele => ele !== null)
                    if (i === +matrixParam - 1) {
                        finalData = sepData
                    }
                    arr = arr.map((el, j) => {
                        if (j === i) {
                            return sepData.length
                        }
                        return el
                    })
                    setRaciLength(arr)
                }
                // arr.forEach((ele, i) => {
                //     sepData.filter((item) => (+item.raciiMatrices.find(el => el.userId === +compUserId && i + 1 === el.raciId)))
                // })
                setTempData(JSON.parse(JSON.stringify(finalData)))
                setCompliancePreview(finalData)
                setRaciLength(arr)
            } else {
                const getData = await GetAllCompliancePreview(compUserId, orgId, bodyType, roleId)
                const response = await getData
                setData(response.data)
                const finalData = response.data.compliancePreview.map(ele => {
                    arr[ele.raciId - 1] = arr[ele.raciId - 1] + 1
                    return ele
                }).filter(ele => ele.raciId === +matrixParam)
                    .map((ele, i) => {
                        ele.id = i
                        ele.checkbox = false
                        return ele
                    })
                setTempData(JSON.parse(JSON.stringify(finalData)))
                setCompliancePreview(finalData)
                setRaciLength(arr)
            }
            setLoading(false)
        } catch (error) {
            toaster('error', error.message)
            setLoading(false)
        }
    }
    useEffect(() => {
        // Retrieve userId and orgId from localStorage
        if (compUserId !== undefined && compUserId !== null && typeof compUserId !== 'string') {
            getCompliancePreview()
        }
    }, [ location, compUserId ])
    const [ currentPage, setCurrentPage ] = useState(1)
    const [ raciLength, setRaciLength ] = useState([])
    const userId = localStorage.getItem('userId')
    const isAdmin = JSON.parse(localStorage.getItem('isAdmin'))
    const rowsPerPage = 5
    const [ transferTableSearchValue, setTransferTableSearchValue ] = useState('')
    const totalPages = Math.ceil(compliancePreview.filter(ele => ele[typePreviewTransferCondition(type) ? 'regulationName' : 'complianceTitle']?.toLowerCase().includes(transferTableSearchValue))?.length / rowsPerPage)
    const [ entries, setEntries ] = useState({
        entry: 0,
        from: 0,
        to: 0
    })
    const handlePageChange = (event, value) => {
        setCurrentPage(value)
    }
    const handleStatusToggle = (status) => {
        navigate(routePath + '?bodyType=' + bodyType + '&roleId=' + roleId + '&userId=' + compUserId + '&matrix=' + status)

        setCurrentPage(1)
    }

    const handleChange = (event, newEvent) => {
        setValue(newEvent)
        navigate(routePath + '?bodyType=' + newEvent + '&roleId=' + roleId + '&userId=' + compUserId + '&matrix=' + matrixParam)
        setCurrentPage(1)
    }
    const IOSSwitch = styled((props) => (
        <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
    ))(({ theme }) => ({
        width: 36,
        height: 20,
        padding: 0,
        '& .MuiSwitch-switchBase': {
            padding: 0,
            margin: 2,
            transitionDuration: '300ms',
            '&.Mui-checked': {
                transform: 'translateX(16px)',
                color: '#fff',
                '& + .MuiSwitch-track': {
                    backgroundColor: 'hsl(var(--primary))',
                    opacity: 1,
                    border: 0
                },
                '&.Mui-disabled + .MuiSwitch-track': { opacity: 0.5 }
            },
            '&.Mui-focusVisible .MuiSwitch-thumb': { color: '#33cf4d', border: '6px solid #fff' },
            '&.Mui-disabled .MuiSwitch-thumb': {
                color: theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[600]
            },
            '&.Mui-disabled + .MuiSwitch-track': { opacity: theme.palette.mode === 'light' ? 0.7 : 0.3 }
        },
        '& .MuiSwitch-thumb': { boxSizing: 'border-box', width: 16, height: 16 },
        '& .MuiSwitch-track': {
            borderRadius: 26 / 2,
            backgroundColor: 'hsl(var(--primary))', // Always primary color
            opacity: 1,
            transition: theme.transitions.create(['background-color'], { duration: 500 })
        }
    }))

    const onSwitchChange = (e) => {
        setTransferTableSearchValue('')
        if (type === bodyPreview.NAME) {
            navigate(`/GRC/${username}/compliance-preview?bodyType=1&roleId=${roleId}&userId=${compUserId}&matrix=1`)
        } else {
            navigate(`/GRC/${username}/body-preview?bodyType=1&roleId=${roleId}&userId=${compUserId}&matrix=2`)
        }
    }
    return (
        <>
            <Loading isLoading={loading} />
            <div className=" flex flex-col flex-grow gap-1 pt-5 px-5 h-[100%] !overflow-auto ">
                {<div className={cn(!typeBodyCompCondition(type) ? 'h-[10%]' : 'h-[6%]', ' flex-shrink-0 flex items-center mx-6')}>
                    <div style={{ display: 'flex', backgroundColor: 'hsl(var(--primary-foreground))', borderRadius: '100px', height: '40px', width: 'fit-content', padding: '0', overflow: 'hidden' }}>
                        {lawTypes?.map((item) => {
                            return (
                                <>
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            padding: '10px 20px',
                                            margin: '5px',
                                            borderRadius: '100px',
                                            cursor: 'pointer',
                                            backgroundColor: value + '' === item.value + '' ? 'hsl(var(--primary))' : '',
                                            color: value + '' === item.value + '' ? 'hsl(var(--card))' : 'hsl(var(--muted))',
                                            transition: 'background-color 0.3s, color 0.3s'
                                        }}
                                        className={cn(value + '' === item.value + '' ? '' : '!font-regular', 'text-h5')}
                                        onClick={() => handleChange(null, item.value)} >{item.label}</div>
                                </>
                            )
                        })}
                    </div>
                    {!typeBodyCompCondition(type) && <TransferRaciContainer setTransferTableSearchValue={setTransferTableSearchValue} type={type}/>}
                </div>}
                <Card className="flex flex-col h-[89%] !overflow-auto m-6">
                    <Box className='flex-grow !overflow-auto' sx={{ width: '100%', height: '85%' }}>
                        {<TabContext value={+matrixParam - 1}>
                            <Box sx={{ borderBottom: 2, padding: '0 20px' }} className='text-primary-foreground flex justify-between'>
                                <TabList
                                    sx={{
                                        '& .MuiTabs-indicator': { background: 'hsl(var(--primary))' },
                                        display: 'flex',
                                        alignItems: 'center',
                                        transform: 'translateY(2px)'
                                    }}
                                >
                                    {
                                        matrix.map((item, i) => {
                                            return (

                                                <>
                                                    {/* raciLength?.[i] > 0 &&  */}
                                                    { <Tab style={{ display: ((typePreviewTransferCondition(type) && (item.value === 1 || item.value === 3 || item.value === 4)) || (!typePreviewTransferCondition(type) && (item.value === 3 || item.value === 4))) && 'none', margin: '0 9px' }} label={<div className='flex gap-1 items-center justify-center'><div className='text-h4' style={{ color: item.value === +matrixParam ? 'black' : 'hsl(var(--muted))' }}>{item.label}</div><div style={{ color: 'hsl(var(--primary))', backgroundColor: 'hsl(var(--primary-foreground))', fontSize: '12px', borderRadius: '50%', minWidth: '20px', minHeight: '20px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                        {raciLength?.[i]}
                                                    </div></div>} value={+item.value} onClick={() => { handleStatusToggle(item.value) }} sx={{ textTransform: 'none', '&.Mui-selected': { color: 'hsl(var(--muted))' }, padding: '0px' }} />}
                                                </>
                                            )
                                        }
                                        )
                                    }
                                </TabList>
                                {typeBodyCompCondition(type) && <div className='flex items-center '>
                                    <div className={cn(type === bodyPreview.NAME ? 'text-primary' : 'text-muted')}>Regulation</div>
                                    <IOSSwitch sx={{ my: 2, ml: 2, mr: 1 }} checked={type !== bodyPreview.NAME} onChange={onSwitchChange} />
                                    <div className={cn(type !== bodyPreview.NAME ? 'text-primary' : 'text-muted')}>Compliance</div>
                                </div>}
                            </Box>
                        </TabContext>}
                        <div className='flex justify-between items-center p-3'>
                            <CustomSearchField
                                value={transferTableSearchValue}
                                setSearch={setTransferTableSearchValue}
                                onValueChange={(e) => setTransferTableSearchValue(e)}
                            />
                            <Button className={cn(compliancePreview?.some(ele => ele.checkbox) ? 'text-primary' : '!bg-[#e5e5e5] !shadow-none pointer-events-none text-[hsl(var(--card))] !border-none ', 'bg-none  border border-primary hover:bg-primary-foreground ')} variant='outlined' onClick={() => setOpenModal(true)}>
                                <BiTransferAlt size={20} style={{ marginRight: '8px' }}/>
                                <span>Reassign</span>
                            </Button>
                        </div>
                        <TcModal isOpen={openModal} setSelectAll={setSelectAll} getCompliancePreview={getCompliancePreview} type={type} handleClose={() => setOpenModal(false)} userData={data} compliancePreview={compliancePreview}/>
                        <div className='p-3'>
                            <TransferComplianceContainer
                                type={type}
                                selectAll={selectAll}
                                setSelectAll={setSelectAll}
                                setEntries={setEntries}
                                routePath={routePath}
                                rowsPerPage={rowsPerPage}
                                setIsSelectRegulation={false}
                                regulationTableData={compliancePreview}
                                currentPage={currentPage}
                                tempData={tempData}
                                setCurrentPage={setCurrentPage}
                                transferTableSearchValue={transferTableSearchValue}
                            />
                        </div>
                    </Box>
                    <PaginationComp
                        data={data?.[typePreviewTransferCondition(type) ? 'bodyPreview' : 'compliancePreview']}
                        entries={entries}
                        totalPages={totalPages}
                        currentPage={currentPage}
                        handlePageChange={handlePageChange}
                    />
                </Card>
            </div>
        </>
    )
}

export default TransferPreview
